import { useMemo } from 'react'

import { useIsMobile } from 'src/shared/hooks/use-mobile'

import type { UserZillowReview } from '../../../api/marketplace/use-user-reviews'
import { MiniZillow } from '../../../assets/mini-zillow'
import { ReviewStar } from '../../../assets/review-star'
import ProfileAvatar from '../../profile-photos/profile-avatar'
import { getNumberOfStars } from '../util/get-number-of-stars'

interface ReviewCardProps {
  review: UserZillowReview
}

const ReviewCard = ({ review }: ReviewCardProps) => {
  const isMobile = useIsMobile()

  const descriptionText = useMemo(() => {
    if (!review.serviceDescription) return ''

    if (!review.locationZipcode) return review.serviceDescription

    return `${review.serviceDescription} in ${review.locationZipcode}`
  }, [review.serviceDescription, review.locationZipcode])

  const dateText = useMemo(() => {
    if (!review.date) return ''
    return new Date(review.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
  }, [review.date])

  return (
    <div className="flex flex-col gap-[10px] border-t py-8">
      <div className="mb-[10px] flex items-center gap-2">
        <ProfileAvatar userId={-1} size={isMobile ? 45 : 50} />
        <div className="flex flex-col">
          <div className="text-lg font-bold">{review.reviewerFullName || 'Anonymous'}</div>
          <div className="text-sm text-gray-500">{descriptionText}</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <MiniZillow size={15} />
        <div className="flex items-center gap-1">
          {[...Array(getNumberOfStars(review.rating ?? 0))].map((_, index) => (
            <ReviewStar key={index} size={15} pattern="black" />
          ))}
        </div>
        <p className="text-muted">{'•'}</p>
        <p className="mt-[2px] text-sm font-semibold text-muted">{dateText}</p>
      </div>
      <div className="text-sm text-gray-500">{review.description}</div>
    </div>
  )
}

export default ReviewCard
